var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgMp3 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#664172",
  fillRule: "evenodd",
  d: "M9 0h7l6 6v15a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16 0v4a2 2 0 0 0 2 2h4z",
  opacity: 0.6
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 8,
  x: 2,
  y: 13,
  fill: "#F7F8FA",
  rx: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#664172",
  d: "M4 15.053h1.22l1.034 2.41h.048l1.035-2.41h1.22v3.894h-.96v-2.392h-.033l-.98 2.367h-.612l-.98-2.38H4.96v2.405H4zM9.171 18.947v-3.894h1.683q.459 0 .79.171.335.169.516.474.18.302.18.703.001.403-.184.706a1.2 1.2 0 0 1-.524.465 1.8 1.8 0 0 1-.807.166h-1.04v-.742h.857a.8.8 0 0 0 .372-.074q.15-.075.228-.207a.6.6 0 0 0 .078-.314.6.6 0 0 0-.078-.312.5.5 0 0 0-.229-.205.9.9 0 0 0-.371-.072h-.486v3.135zM14.368 19q-.465 0-.825-.152a1.4 1.4 0 0 1-.566-.424 1 1 0 0 1-.21-.622h.99a.38.38 0 0 0 .086.227.5.5 0 0 0 .217.152.8.8 0 0 0 .312.055q.175 0 .309-.06.135-.06.21-.165a.4.4 0 0 0 .074-.243.37.37 0 0 0-.081-.243.54.54 0 0 0-.237-.166 1 1 0 0 0-.358-.059h-.396v-.669h.396q.18 0 .318-.057a.5.5 0 0 0 .217-.16.38.38 0 0 0 .076-.24.4.4 0 0 0-.066-.23.43.43 0 0 0-.185-.155.768.768 0 0 0-.57 0 .5.5 0 0 0-.208.156.4.4 0 0 0-.082.234h-.94a1 1 0 0 1 .202-.612q.2-.267.541-.417.345-.15.784-.15.438 0 .77.146.332.147.518.4a.93.93 0 0 1 .185.568q.002.33-.225.542-.225.213-.58.262v.03q.475.054.715.293a.8.8 0 0 1 .241.6q0 .338-.209.6a1.4 1.4 0 0 1-.577.41 2.3 2.3 0 0 1-.846.149"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMp3);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;